import {createLogic} from "redux-logic";
import * as Action from "./action";
import * as Types from "./types";
import _ from "lodash";
import debugLog, {LogLevel} from "../utils/debugLog";

const updateSegmentsLogic = createLogic({
  type: Types.GET_BUS_ETA,
  warnTimeout: 0,
  latest: true,
  processOptions: {
    dispatchMultiple: true,
  },
  async process({action, httpClient, getState}: any, dispatch, done) {
    const {routes} = action.payload;

    let allRouteLocation: any[] = [];

    try {
      const routesRes = await httpClient.get(
        `${process.env.REACT_APP_SERVER_URL}/api/routesByIds?Ids=${_.map(
          routes,
          (route) => route.id
        )}&IsGetAssignments=True`
      );

      routesRes.data.forEach((route: any) => {
        allRouteLocation = [...allRouteLocation, ...route.routeLocations];
      });

      dispatch(Action.getAllAssignment(routesRes.data));

      dispatch(Action.updateRouteByIds(allRouteLocation));

      dispatch(Action.getAllRouteLocation(allRouteLocation));

      const uniqueLocations: any[] = [];
      allRouteLocation.forEach((location) => {
        const target = _.find(uniqueLocations, {
          locationId: location.locationId,
        });
        if (target) {
          target.routeIds = _.uniq([...target.routeIds, location.routeId]);
        } else {
          uniqueLocations.push({...location, routeIds: [location.routeId]});
        }
      });

      dispatch(Action.updateLocationList(uniqueLocations));
    } catch (error) {
      debugLog(LogLevel.ERROR, 'Unable to get `updateSegmentsLogic()`. ', {
          error: error,
      });
      throw error;
    }

    done();
  },
});

const getAllEtaLogic = createLogic({
  type: Types.GET_ALL_ETA,
  warnTimeout: 0,
  processOptions: {
    dispatchMultiple: true,
  },
  async process({action, httpClient}: any, dispatch, done) {
    const {data} = action.payload;

    try {
      // Fetch data
      var allEta: any = [];
      data.forEach(async (route: any) => {
        const response = await httpClient.get(
          `${process.env.REACT_APP_SERVER_URL}/api/directions/${route.id}`
        );

        if (response.status === 200 && response.data) {
          allEta.push(response.data);
        } else {
          console.warn(`Failed to fetch data for route ${route.id}`);
        }
      });

      dispatch(Action.getAllEtaSuccess(allEta));
    } catch (error) {
      debugLog(LogLevel.ERROR, 'Unable to get `getAllEtaLogic()`. ', {
          error: error,
      });
      console.error("Error fetching data:", error);
    }
    done();
  },
});

const getRouteTagsLogic = createLogic({
  type: Types.GET_ROUTE_TAGS,
  warnTimeout: 0,
  processOptions: {
    dispatchMultiple: true,
  },
  async process({httpClient}: any, dispatch, done) {
    try {
      const routeTags = await httpClient.get(
        `${process.env.REACT_APP_SERVER_URL}/api/RouteTags?Filter={"TenantId": ${process.env.REACT_APP_TENANT_ID}}&PageSize=100`
      );

      const tags = await httpClient.get(
        `${process.env.REACT_APP_SERVER_URL}/api/tags?Filter={"TenantId": ${process.env.REACT_APP_TENANT_ID}}&PageSize=100`
      );

      const mappedTags = await Promise.all(
        tags.data.map((tagItem: any) => {
          return {
            ...tagItem,
            routes: _.filter(routeTags.data, (o) => {
              return o.tagId === tagItem.id;
            }),
          };
        })
      );
      const reversMappedTags = mappedTags.reverse();

      dispatch(Action.getRouteTagsSuccess(reversMappedTags));
    } catch (error) {
      debugLog(LogLevel.ERROR, 'Unable to get `getRouteTagsLogic()`. ', {
          error: error,
      });
      throw error;
    }

    done();
  },
});

const setNtpLogic = createLogic({
  type: Types.SET_NTP,
  warnTimeout: 0,
  processOptions: {
    dispatchMultiple: true,
  },
  async process({action}: any, dispatch, done) {
    const {data} = action.payload;

    dispatch(Action.setNtpSuccess(data));

    done();
  },
});

const logicExport = [updateSegmentsLogic, getRouteTagsLogic, getAllEtaLogic, setNtpLogic];
export default logicExport;